//  CALENDAR CONSTANTS

// JQuery UI -- Pick which one of these looks better
//var classJQueryUI = "ui-state-default ui-widget-content ui-widget-header";
//var classJQueryUI = "ui-state-highlight ui-widget ui-state-default";
var classJQueryUI = "ui-widget ui-state-default";

var cal;                 // Used for printing

var DAYS_OF_WEEK = 7;    // constant for number of days in a week
var DAYS_OF_MONTH = 31;  // constant for number of days in a month
var DAYS_TO_SHOW = 21;   // constant for number of days to show in the calendar (3 weeks at a time)
var PROJECTION = 14;     // number of days for projection of last day shown

var day_of_week = new Array('Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday');
var month_of_year = new Array('January','February','March','April','May','June','July','August','September','October','November','December');

//  DECLARE AND INITIALIZE VARIABLES
var tmpCal = new Date();
var todaysDate = tmpCal.getDate();
var todaysMonth = tmpCal.getMonth();

var navlinkclass="calendarnav";

var startOrderLink = "?command=catalogpage&name=profile&parm=nothing";

//	This represents 3 week increment shifts from today's date to keep track of calendar "pages"
var displayShiftDate = new Date();

var weekNumber = 0;

// figure date for 3 weeks from today (21 days)
//Calendar.setDate(Calendar.getDate() + 21);
//var threeWeeksDate = Calendar.getDate();
//var threeWeeksMonth = Calendar.getMonth();
//Calendar.setDate(Calendar.getDate() - 21);

function nextThreeWeeks() {
	//shift forward 3 weeks
	displayShiftDate.setDate(displayShiftDate.getDate() + 21);
	weekNumber += 3;

	drawCalendar();
}

function previousThreeWeeks() {
	//shift backward three weeks
	displayShiftDate.setDate(displayShiftDate.getDate() - 21);
	weekNumber -= 3;

	drawCalendar();
}


function drawCalendar() {
	// start calendar at beginning of this week
	firstDate = new Date(displayShiftDate);
	firstDate.setDate(firstDate.getDate() - firstDate.getDay());

	// set the calendar title, spanning 2 months if necessary
	var beginningMonth = firstDate.getMonth();
	var CALENDAR_TITLE = month_of_year[beginningMonth]; // append first week's sunday's month to title
	
	lastDate = new Date(firstDate);
	lastDate.setDate(firstDate.getDate() + 20);
	if(lastDate.getMonth() != beginningMonth) { // append next month to title
		CALENDAR_TITLE = CALENDAR_TITLE + "/" + month_of_year[lastDate.getMonth()];
	}

	CALENDAR_TITLE = CALENDAR_TITLE + " Calendar"; // finish calendar title
	
	// BEGIN CODE FOR CALENDAR
	
	// div container
	cal = '<div class="toprow">';
	// title
	cal += '<table width="99%"><tr><td width="1%"><nobr><h2>' + CALENDAR_TITLE + '</h2></nobr></td>';	
	// back/forth links - coming from host page, probably call back to server need [prevNextLink]
	cal += '<td align="right"><div class="calendar-buttons">';
	cal += '<input type="button" onclick="window.location.search=\''+startOrderLink+'\'" value="Place an order" role="button" class="calendar-placeorderbutton orderFlow ui-button ui-corner-all ui-widget">';
	if(weekNumber == 0) {
		cal += '<input id="calendarNext" type="button" class="ui-state-highlight '+navlinkclass+ '" onclick="nextThreeWeeks(); $(\'.calendarnav\').button();" value="Next Three Weeks >>">';
	} else if(weekNumber == weeksToDisplay - 3) {
		cal += '<input id="calendarPrev" type="button" class="ui-state-highlight '+navlinkclass+ '" onclick="previousThreeWeeks(); $(\'.calendarnav\').button();" value="<< Previous Three Weeks">';
	} else {
		cal += '<input id="calendarPrev" type="button" class="ui-state-highlight '+navlinkclass+ '" onclick="previousThreeWeeks(); $(\'.calendarnav\').button();" value="<< Previous Three Weeks">';
		cal += '<input id="calendarNext" type="button" class="ui-state-highlight '+navlinkclass+ '" onclick="nextThreeWeeks(); $(\'.calendarnav\').button();" value="Next Three Weeks >>">';
	}
	
	cal += '</div></td></tr></table>';
	// end div
	cal += '</div><br clear="all">';	
	
	// open table for calendar
	cal +=  '<table cellpadding="2" cellspacing="1" border="0" width="100%" class="ui-widget">';
	//cal +=  '<table cellpadding="2" cellspacing="1" border="0" width="100%" class="ui-widget ui-widget-content ui-helper-clearfix">';
	
	// header row of calendar 
	cal += '<thead>';
	cal += '<tr>';
	
	// first cell, before 'Sun' - customizeable link from host page [firstColumnLink]
	//NOTE: showWeekLinkColumn is set on the calendar page.
	if(showWeekLinkColumn==true){
		cal += '<td class="topleft">' + firstColumnLink + '</td>';
	}
	
	// loop for each day of the week - headers
	for(index=0; index < DAYS_OF_WEEK; index++)
		cal += '<td class="ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-top" valign="bottom">&nbsp;' + day_of_week[index] + '</td>';
	
	// end header row of table 
	cal += '</tr>';
	cal += '</thead>';
	cal += '<tbody>';
	
	// loop for each day to show in the calendar
	currentDate = firstDate;
	var weekOffeset = 0;
	for(index=0; index < DAYS_TO_SHOW; index++)
	{
		// get day to print
		week_day = currentDate.getDay();
	
		// start new row for first day of week
		if(week_day == 0) {
			// set the first cell of week - the links, host page needs vars [week1Links] [week2Links] [week3Links]
			var weekLinks = weekLinksArray[weekNumber + weekOffeset];
			
			// set which dayInfo array to use - host page needs vars [week1_dayInfo, week2_dayInfo, week3_dayInfo]
			var dayInfo = weekDayInfoArray[weekNumber + weekOffeset];
			
			cal += '<tr>';
			//NOTE: showWeekLinkColumn is set on the calendar page.
			if(showWeekLinkColumn==true){
				cal += '<td class="ui-datepicker-header ui-widget-header ui-helper-clearfix weeklinks" valign="top"><span class="ui-state-hover weekly">Weekly Items</span>' + 
					weekLinks + '</td>';
			}
		}
	
		// for each day of the week
		// set correct class for the cell
		var day  = currentDate.getDate();

		var classStr = classJQueryUI + " day";
		if(currentDate.getDay() == 0 && showWeekLinkColumn==false)
			classStr = classJQueryUI + " day firstday";
		if(currentDate.getDay() == 6)
			classStr = classJQueryUI + " day lastday";
		if(day == todaysDate && currentDate.getMonth() == todaysMonth)
			classStr = "ui-state-active ui-widget-content ui-widget-header day today";
			
		// print day cell
		cal += '<td class="' + classStr + '"><span class="daynumber">' + day + '</span>';
		
		// insert any information for that day
		//if(document.all('day_' + day + '_insert'))
		cal += dayInfo[currentDate.getDay()];
			
		// close cell
		cal += "</td>"

		// end row on last day of week
		if(week_day == 6) {
			cal += '</tr>';
			weekOffeset += 1;
		}
	
		// increment for next week
		currentDate.setDate(currentDate.getDate()+1);
	}
	
	// end table
	cal += '</tbody>';
	cal += '</table>';
	
	// print calendar
	if(document.getElementById)
		document.getElementById("calendarDiv").innerHTML = cal;
	if(document.all)
		document.all["calendarDiv"].innerHTML = cal;
	if(document.layers) {
		var d = document.layers["calendarDiv"];
		d.document.open();
		d.document.writeln(cal);
		d.document.close();;
	}
}
